import React, { useState, useEffect, useContext } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import CircularProgressBar from "../../utils/CircularProgressBar";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import TextField from "@mui/material/TextField";
import { convertInDate } from "../../utils";
import { createeDetail, validateDeckName, validateDAMS, getDocVeevaMetaDetails } from "../../services/apis";
import SharedResource from "../SharedResource/SharedResource";
import CommonAutocompleteDropdown from "../ResuableComponent/CustomModal/DropdownWithFilter/CommonAutocompleteDropdown";
import "./webactionStyle.scss";
import { showErrorToast, showSuccessToast } from "../toastComponent/ToastComponent";

const WebActionVeeva = ({
  showModal,
  setShowModal,
  /* localShared,
  setLocalShared, */
  brands,
  marketLi,
  marketDataList,
}) => {
  const [isloading, setIsloading] = useState(false);
  const [queryString, setQueryString] = useState({});
  const [payloadObj, setPayloadObj] = useState({});
  const [userName, setUserName] = useState("");
  const [isOpenSharedModal, setIsOpenSharedModal] = useState(false);
  const [nameValidateMsg, setNameValidateMsg] = useState("");
  const [error, setError] = useState(false);
    const [ratios, setRatios] = useState([]);
  
  const [deckIdCurrent, setDeckIdCurrent] = useState();
  const [localShared, setLocalShared] = useState(false);
  const [localSharedToggle, setLocalSharedToggle] = useState(false);
  const [disableBtn, setDisableBtn] = useState(true)
  const [responsiveEnable, setResponsiveEnable] = useState(false);
  const [ docMeta, setDocMeta] = useState([]);
  const [ veevaDocName, setVeevaDocName] = useState(null);
  
  

  const navigate = useNavigate();
  const location = useLocation();
  const gotToDashboard = () => {
    setShowModal(false);
    navigate(`/`, {
      replace: true,
    });
  };

  useEffect(() => {
    setIsloading(true)
    const search = location.search;
    const brand = new URLSearchParams(search).get("product");
    const market = new URLSearchParams(search).get("country"); //
    const docId = new URLSearchParams(search).get("documentNumber");
    const type = new URLSearchParams(search).get("type");
    
    setQueryString({
      product: brand,
      country: market,
      docId: docId,
      type: type,
    });
    let nameObj = localStorage.getItem("currentUserName");
    setUserName(nameObj);
    
    setPayloadObj({
      brand: brand,
      market: market,
      name: "",
      type: type,
      default_aspect_ratio: null
    });
    setRatios([
      {value:'1024 x 768', id:'dim_1024*768'},
      { value: '2048 x 1536', id: "dim_2048*1536" },
    { value: '2388 x 1668', id: 'dim_2388*1668' },
    { value: '2752 x 2064', id: 'dim_2752*2064' },
    
    ])

    validateDocNumber({ docNumber: docId, deckType: Number(type), assetType: 1 })
    getDocVeevaMetaDetails(docId, (response, err, errorCode) => {
      if(response?.data?.response?.docMeta?.length) {
        setDocMeta(response?.data?.response?.docMeta[0]?.docIndication || []);
        setVeevaDocName(response?.data?.response?.docMeta[0]?.docName || '');
      }
    });
  }, []);

  const validateMeta = () => {
    if (
      payloadObj?.name?.length <= 30 && payloadObj?.name?.length >= 3 &&
      payloadObj.brand &&
      payloadObj.market &&
      payloadObj.type
    ) {
      return false;
    } else {
      return true;
    }
  };

  const storeBasicDetail = async() => {
    setIsloading(true);
    const data = { brand: "", market: "", edetailName: "" };
    const brandFind = brands.filter(
      (brand) =>
        brand.veevaid === payloadObj?.brand || brand?.name === payloadObj?.brand
    );
    const countryFind = marketDataList.filter(
      (market) =>
        market.veevaid === payloadObj?.market ||
        market.name === payloadObj?.market
    );
    /* const countryFind =
      marketDataList[
        marketLi
          .map((li) => li.toUpperCase())
          .indexOf(payloadObj?.market?.toUpperCase())
      ]; */
    data.brand = brandFind[0];
    data.market = countryFind[0];
    data.edetailName = payloadObj?.name;
    data.type = Number(payloadObj.type);
    data.docNumber = queryString.docId;
    data.indication = docMeta;
    // console.log(data, "-----localstorage", marketDataList, payloadObj.market);
    localStorage.setItem("basicEdetailData", JSON.stringify(data));
     const valid = await validateDeckName({ name: payloadObj?.name },Number(payloadObj.type));
    if (valid?.success) {
      setIsloading(false);
      navigate(`/module`, {
        replace: true,
        state: data,
      });
    } else {
      if (valid.err) {
        const errMsg = valid.err;
        setNameValidateMsg(errMsg.hasOwnProperty('message') ? errMsg?.message : errMsg);
        setIsloading(false);
        return;
      }
    }
    
  };

  const createHandler = async () => {
    setIsloading(true);
    const data = {
      brand: "",
      market: "",
      name: "",
      device: null,
      dimension: null,
      indication: '',
      slides: [],
      thumbnail: "",
      tags: [],
      created: {
        userid: "",
        username: "",
        name: "",
      },
      desc: "",
      default_aspect_ratio: null,//"dim_2048*1536",
    };
    const brandFind = brands.filter(
      (brand) =>
        brand.veevaid === payloadObj?.brand || brand.name === payloadObj?.brand
    );
    const countryFind = marketDataList.filter(
      (market) =>
        market.veevaid === payloadObj?.market ||
        market.name === payloadObj?.market
    );
    data.brand = brandFind[0]._id;
    data.market = countryFind[0]._id;
    data.name = payloadObj?.name;
    data.type = Number(payloadObj.type);
    data.indication = docMeta;
    data.docNumber = queryString.docId;
    data.default_aspect_ratio = payloadObj.default_aspect_ratio ? ratios.filter((r) => r.value === payloadObj.default_aspect_ratio)[0].id : null;
   
     const valid = await validateDeckName({ name: payloadObj?.name },Number(payloadObj.type));
    if (valid?.success) {
      createeDetail(data, (response, err, errCode) => {
      if (err) {
        console.log('err', err)
        if (errCode === 400) {
          
           showErrorToast(err.hasOwnProperty('message')? err?.message : err);
        }
       
        setIsloading(false);
      } else {
        showSuccessToast(`${queryString.type == 1 ? "Template" : "e-Detail"} Created
          Successfully`);
        const returnedResponse = response?.data?.response;
        const pageId = returnedResponse.slides[0].slideid._id;
        if (localShared) {
          setDeckIdCurrent(returnedResponse);
          setIsOpenSharedModal(true);
          setShowModal(false);
          setIsloading(false);
        } else {
          setIsloading(false);
          navigate(`/editor/${pageId}`);
        }
        
      }
    });
    } else {
      if (valid.err) {
        const errMsg = valid.err;
        setNameValidateMsg(errMsg.hasOwnProperty('message') ? errMsg?.message : errMsg);
        setIsloading(false);
        return;
      }
    } 

    
  };

  const validateName = async() => {
    const valid = await validateDeckName({ name: payloadObj?.name },Number(payloadObj.type));
    if (valid?.success) {
      setError(false)
    } else {
      if (valid.err) {
        const errMsg = valid.err;
        setNameValidateMsg(errMsg.hasOwnProperty('message') ? errMsg.message : errMsg);
        setError(true)
      }
    }
    
  };

  const focusedHandler = () => {
    if (payloadObj?.name?.trim().length < 3 && payloadObj?.name?.trim().length > 30) {
      setError(true);
    }
  };

  const nameValidation = (e) => {
    const specialChars = /[`!@#$%^&*+\=\[\]{};':"\\|,.<>\/?~]/;
    if (specialChars.test(e.target.value) || e.target.value.includes(" "))
      return;
    setPayloadObj({ ...payloadObj, name: e.target.value });
    if (e.target.value.length > 30) {
      //showErrorToast('Name exceeded the maximum length');
      setNameValidateMsg('Name exceeded the maximum length');
      setDisableBtn(true);
      setError(true);
      return;
    } else if (e.target.value.length <= 30 && e.target.value.length >= 3) {
      setNameValidateMsg('');
      setDisableBtn(false);
      setError(false);
    } else if (e.target.value.length < 3) {
      setNameValidateMsg('Please use minimum 3 characters');
      setDisableBtn(true);
      setError(true);
    }
  };

  const validateDocNumber = (payloadObj, typeNo) => {
    
    validateDAMS(payloadObj, (response, err, errorCode) => {
     
      if (err) {
        gotToDashboard()
      } else {
        setShowModal(true)      
       setIsloading(false)
      }
    })
  }

  const templateListUI = (props, option, { selected }) => {
    const { key, ...optionProps } = props;
    return (
      <li {...props} className="dropdown-list-css">
        <span>{option.name || option}</span>
      </li>
    );
  };
  
  const selectionDimension = (e, newValue, label) => {
    if (label.includes("Dimension")) {
      setPayloadObj({
        ...payloadObj,
        default_aspect_ratio: newValue,
      });
      // console.log(newValue,'----------------------------')
    }
  }
  return (
    <>
      {" "}
      {isloading && (
        <CircularProgressBar
          isloading={isloading}
          setIsloading={setIsloading}
        />
      )}
      <Modal
        show={showModal}
        //onHide={gotToDashboard}
        // className="template-forms"
        dialogClassName="new-template-forms gilead-modal-border"
      >
        <Modal.Body className="new-template-forms-modal">
          <div className="d-flex create-template-main">
            <section className="create-template-left-section">
              <div className="create-template-left-section-content">
                <h2 className="create-template-left-section-header">
                  METADATA INFORMATION
                </h2>
                <div className="create-template-source">
                  <h3 className="create-template-source-name">Source</h3>
                  <p className="create-template-source-content">PromoMats</p>
                </div>
                <div className="create-template-created-by">
                  <h3 className="create-template-created-by-name">
                    Created by
                  </h3>
                  <p className="create-template-created-by-content">
                    {userName}
                  </p>
                </div>
                <div className="create-template-created-on">
                  <h3 className="create-template-created-on-name">
                    Created on
                  </h3>
                  <p className="create-template-created-on-content">
                    {convertInDate(Date(), "normal")}
                  </p>
                </div>
                <div className="create-template-created-on">
                  <h3 className="create-template-created-on-name">
                    Promomats Material Doc ID
                  </h3>
                  <p className="create-template-created-on-content">
                    {queryString.docId}
                  </p>
                </div>
                <div className="create-template-created-on">
                  <h3 className="create-template-created-on-name">Product</h3>
                  <p className="create-template-created-on-content">
                    {/* {queryString.product} */}
                    {
                      brands?.filter(
                        (brandlist) => brandlist?.veevaid == queryString.product
                      )[0]?.name
                    }
                  </p>
                </div>
                <div className="create-template-created-on">
                  <h3 className="create-template-created-on-name">Country</h3>
                  <p className="create-template-created-on-content">
                    {/* {queryString?.country?.substring(0, 1).toUpperCase() +
                      queryString?.country?.substring(1)} */}

                    {
                      marketDataList.filter(
                        (market) =>
                          market.veevaid === queryString?.country ||
                          market.name === queryString?.country
                      )[0]?.name
                    }
                  </p>
                </div>
              </div>
            </section>
            <section className="create-template-right-section">
              <div className="create-template-right-section-content">
                <TextField
                  className={`create-template-input-field`}
                  size="small"
                  variant="outlined"
                  name="templateName"
                  fullWidth={true}
                  required
                  style={{
                    fontSize: "12px",
                    transformOrigin: "top",
                    color: "#66676b",
                    // marginTop: "4px"
                    borderRadius: "6px",
                  }}
                  label={
                    queryString.type == 1 ? "Template Name" : "e-Detail Name"
                  }
                  value={payloadObj.name}
                  onChange={(e) => {
                    nameValidation(e);
                  }}
                  autoComplete="off"
                  helperText={
                    payloadObj?.name?.trim().length < 3 && error
                      ? "Please use minimum 3 characters"
                      : nameValidateMsg
                      ? nameValidateMsg
                      : ""
                  }
                  error={
                    payloadObj?.name?.trim().length < 3 || nameValidateMsg
                      ? error
                      : ""
                  }
                  onBlur={() => {
                    focusedHandler();
                    validateName();
                  }}
                ></TextField>
                {queryString.type == 1 && (
                  <div
                    className="d-flex add-shared-resources"
                    style={{ marginTop: "14px", marginBottom: "16px" }}
                  >
                    <input
                      type="checkbox"
                      checked={localSharedToggle}
                      className="create-template-checkbox"
                      name="shared_toggle"
                      onChange={(e) => {
                        setLocalSharedToggle(e.target.checked);
                        setLocalShared(e.target.checked);
                      }}
                    />
                    <p>Add Shared Resources</p>
                  </div>
                )}

{queryString.type == 1 && <div className="d-flex add-shared-resources" style={{ marginTop: '14px', marginBottom: "16px" }}>
                    <input
                      type="checkbox"
                      checked={responsiveEnable}
                      className="create-template-checkbox"
                      name="shared_toggle"
                      onChange={(e) => {
                        setResponsiveEnable(e.target.checked)
                        setPayloadObj({ ...payloadObj, default_aspect_ratio: !e.target.checked ? '' : ratios[0].value })
                      }
                      }
                    />
                    <p>Enable Responsiveness</p>
                  </div>}
                  {responsiveEnable && <div className="" style={{ marginTop: "16px", marginBottom:"16px" }}>
                    
                    <CommonAutocompleteDropdown
                      options={ratios.map(ratio => ratio.value)}
                      disableValue={false}
                      value={payloadObj?.default_aspect_ratio}
                      label="Choose Device Dimension"
                      required={true}
                      renderOption={templateListUI}
                      onChange={selectionDimension}
                    ></CommonAutocompleteDropdown>
                  </div>}
              </div>
            </section>
          </div>
        </Modal.Body>
        <Modal.Footer className="create-template-footer-section event-Btns">
          <Button
            className="cancel-create-template cancle-primary"
            onClick={gotToDashboard}
          >
            CANCEL
          </Button>
          <Button
            className={`cancel-create-template btn-primary-proceed ${
              disableBtn && validateMeta() ? "" : "activeCreate"
            }`}
            disabled={disableBtn && validateMeta()}
            onClick={queryString.type == 1 ? createHandler : storeBasicDetail}
          >
            {queryString.type == 1 ? "CREATE TEMPLATE" : "Create e-Detail"}
          </Button>
        </Modal.Footer>
      </Modal>
      {localShared && ( //
        <SharedResource
          setOpenSharedResource={setIsOpenSharedModal} //
          deckIdCurrent={deckIdCurrent}
          isOpenSharedModal={isOpenSharedModal} //
          modeFrom={"Template"}
        />
      )}
    </>
  );
};
export default WebActionVeeva;
